import { useContext } from "react";
import { AuthContext } from "../context/AuthContext/AuthContext";
import { isTokenExpired } from "../utils/services/Auth/isTokenExpired";

export const useValidToken = () => {
  const { loading: authLoading, user } = useContext(AuthContext);
  const token = localStorage.getItem("token");
  const isValid = !!token && !isTokenExpired(token);

  return {
    token,
    isValid,
    authLoading,
    user
  };
};
